import { __ } from '@wordpress/i18n';

const variations = [
	{
		name: 'simple',
		title: __( 'Form' ),
		description: __( 'Default form' ),
		icon: 'email',
		isDefault: true,
		attributes: {
		},
		innerBlocks: [
			[
				'popper/form-input',
				{
					name: 'name',
					label: 'Name',
					placeholder: 'Your name'
				},
			],
			[
				'popper/form-input',
				{
					name: 'email',
					label: 'Email',
					required: true,
					placeholder: 'Your email'
				},
			],
			[ 'popper/form-button' ],
		],
		scope: [ 'block', 'inserter' ],
	},
	{
		name: 'contact',
		title: __( 'Contact' ),
		description: __( 'Default popup' ),
		icon: 'email',
		attributes: {
		},
		innerBlocks: [
			[
				'popper/form-input',
				{
					name: 'name',
					label: 'Name',
				},
			],
			[
				'popper/form-input',
				{
					name: 'email',
					label: 'Email',
					required: true,
					type: 'email',
				},
			],
			[
				'popper/form-input',
				{
					name: 'subject',
					label: 'Subject',
				},
			],
			[
				'popper/form-input',
				{
					name: 'message',
					label: 'Message',
					type: 'textarea',
					required: true,
				},
			],
			[ 'popper/form-button' ],
		],
		scope: [ 'block', 'inserter' ],
	},
];

export default variations;
